import React from "react";
import { Button } from "@mui/material";
import { enterpriseTokens } from "styles/theme";

/**
 * Common reusable button component
 * @param {string} label - The button text
 * @param {function} onClick - Click handler
 * @param {string} variant - "contained" | "outlined" | "text"
 * @param {string} color - Primary color (default: "primary")
 * @param {object} startIcon - Optional start icon component
 * @param {object} endIcon - Optional end icon component
 * @param {object} sx - Optional custom styles
 * @param {boolean} disabled - Disable state
 */
const CustomButton = ({
    label,
    onClick,
    variant = "contained",
    color = "primary",
    startIcon,
    endIcon,
    sx = {},
    disabled = false,
    ...props
}) => {
    return (
        <Button
            variant={variant}
            color={color}
            onClick={onClick}
            startIcon={startIcon}
            endIcon={endIcon}
            disabled={disabled}
            sx={{
                textTransform: "none",
                borderRadius: "3px",
                fontFamily: "Inter, Outfit, sans-serif",
                fontWeight: 700,
                fontSize: "14px",
                boxShadow: "none",
                padding: "11px 18px",
                color: "#fff",
                backgroundColor: enterpriseTokens.primary,
                lineHeight: "18px",
                border: "1px solid transparent",
                "&:hover": {
                    backgroundColor: enterpriseTokens.primaryDark,
                    boxShadow: "0 6px 14px rgba(29, 78, 216, 0.18)",
                },
                "&.MuiButton-outlined": {
                    color: enterpriseTokens.primary,
                    background: "#FFFFFF",
                    borderColor: enterpriseTokens.line,
                },
                ...sx, // allow custom overrides
            }}
            {...props}
        >
            {label}
        </Button>
    );
};

export default CustomButton;
